export default (pageQueryParam: string | string[] | undefined) => {
  return (
    Number(
      Array.isArray(pageQueryParam) ? pageQueryParam[0] : pageQueryParam,
    ) || 1
  );
};
